export default __webpack_public_path__ + "static/media/vinyl.102a7def.svg";